import { i18n } from '@/locales';
import EmojiOptions from './useEmojiOptions';
import ShapesOptions from './useShapeOptions';
export const stickers = [
    {
        title: i18n.global.t('stickers.emojis.title'),
        url: 'emoji',
        options: EmojiOptions,
        value: 'emojis',
    },
    {
        title: i18n.global.t('stickers.shapes.title'),
        url: 'shape',
        options: ShapesOptions,
        value: 'shapes',
    },
    // {
    //   title: i18n.global.t('stickers.shapes.title'),
    //   url: 'https://storage.googleapis.com/ghl-test/o6241QsiRwUIJHyjuhos/media/650f276c8069a753ede5b8bc.png',
    //   options: [
    //     {
    //       title: 'Rectangle',
    //       value: 'rect',
    //     },
    //     {
    //       title: 'Circle',
    //       value: 'circle',
    //     },
    //     {
    //       title: 'Triangle',
    //       value: 'triangle',
    //     },
    //   ],
    // },
];
